import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MODAL_DATA } from 'src/app/helpers/modal.tokens';

@Component({
  selector: 'app-project-team-add-note-modal',
  templateUrl: './project-team-add-note-modal.component.html',
  styleUrls: ['./project-team-add-note-modal.component.scss']
})
export class ProjectTeamAddNoteModalComponent implements OnInit {

  constructor(
    @Inject(MODAL_DATA) public data: any,
    private dialogRef: MatDialogRef<any>
  ) { }

  ngOnInit(): void {
    console.log(this.data);
    
  }

  close(result: any) {
    this.dialogRef.close(result);
  }

}
